import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import { SimpleTimePipe } from './simple-time.pipe';
import { ToDateObjPipe } from './to-date-obj';
import { CustomTimeFormatPipe } from './custom-time.pipe';
import { JobSearchPipe } from './job-search.pipe';
import { NumberArrayPipe } from './string-to-nums';
import { HoursPipe } from './hours.pipe';

@NgModule({
	declarations: [ SimpleTimePipe, ToDateObjPipe, CustomTimeFormatPipe, JobSearchPipe, NumberArrayPipe, HoursPipe],
	imports: [CommonModule],
	exports: [SimpleTimePipe, ToDateObjPipe, CustomTimeFormatPipe, JobSearchPipe, NumberArrayPipe, HoursPipe]
})
export class PipesModule {
	static forRoot() {
		return {
			ngModule: PipesModule,
			providers: [],
		};
 }
}
